import script from "./HotelBillPartialReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelBillPartialReturn.vue?vue&type=script&setup=true&lang=js"

import "./HotelBillPartialReturn.vue?vue&type=style&index=0&id=8870b01c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8870b01c"]])

export default __exports__